export enum BillingResidency {
    CZ = 'CZ',
    SK = 'SK'
};
